
import { Options, prop, Vue } from "vue-class-component";
import SelectSearchV2 from "@/app/ui/components/select-search/index.vue";
import Checkbox from "primevue/checkbox";
import CustomDropdown from "@/app/ui/components/custom-dropdown/index.vue";
import debounce from "lodash/debounce";
import { BookingController } from "@/app/ui/controllers/BookingController";
import RadioButton from "primevue/radiobutton";
import SelectPhoneCountry from "@/app/ui/views/shipment/booking/component/select-phone-country.vue";
import { ShipmentBookingController } from "@/app/ui/controllers/ShipmentBookingController";
import { ClientController } from "@/app/ui/controllers/ClientController";
import { RouteController } from "@/app/ui/controllers/RouteController";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { getPhoneDisplayCode } from "@/app/infrastructures/misc/common-library/v2/FormatPhoneNumber";
import OverlayPanel from "primevue/overlaypanel";
import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";
import {
  AdvancedFilterData,
  AdvancedFilterFormData
} from "@/domain/entities/CreateBookingV3";
import TimeRangePickerV3 from "@/app/ui/components/time-range-picker-v3/index.vue";
import mapProductTypeName from "@/app/infrastructures/misc/common-library/ProductTypeNameMapper";
import { getCountryScopeParam } from "@/app/infrastructures/misc/CountryScope";

class Props {
  modelValue = prop<any>({
    required: true
  });
  customSenderPhone = prop<string>({
    default: "",
    type: String
  });
}
@Options({
  emits: [
    "change",
    "reset",
    "update:modelValue",
    "changeFilter",
    "resetFilter"
  ],
  components: {
    SelectSearchV2,
    Checkbox,
    CustomDropdown,
    RadioButton,
    SelectPhoneCountry,
    OverlayPanel,
    TimeRangePickerV3
  },
  watch: {
    openFilter() {
      if (!this.openFilter) {
        this.phoneSender = this.filterData.phoneSender;
        this.phoneReceiver = this.filterData.phoneReceiver;
      }
    }
  }
})
export default class Filter extends Vue.with(Props) {
  mounted() {
    this.filterProductsDelivery("");
    this.getInsurancesTypeDelivery();

    this.filterData.phoneSender =
      this.customSenderPhone ||
      ShipmentBookingController.advanceFilterData.phoneSender;
    this.setPhoneSender(this.filterData.phoneSender);
    if (!this.filterData.phoneSender) {
      this.phoneCodeSender = this.defaultPhoneCodeSender;
      this.phoneFlagSender = this.defaultPhoneFlagSender;
    }
  }
  isChevron = false;
  resetSelectSearch = 0;

  resetfilter(value = true) {
    // reset date range jika ada refs
    const refs: any = this.$refs.dateRangeFilter;
    if (refs) {
      refs.dates = { start: null, end: null };
      refs.onDateSelected();
    }

    this.filterData = new AdvancedFilterData();
    this.form = new AdvancedFilterFormData();

    this.phoneReceiver = "";
    this.phoneCodeReceiver = getPhoneDisplayCode(
      AccountController.accountData?.countryCode
    );
    this.phoneFlagReceiver = !this.accountIsForeign ? "indonesia" : "malaysia";
    this.phoneSender = "";
    this.phoneCodeSender = this.defaultPhoneCodeSender;
    this.phoneFlagSender = this.defaultPhoneFlagSender;

    this.resetSelectSearch++;
    this.$emit("reset", value);
  }

  // filter data to be sent
  filterData = new AdvancedFilterData();
  form = new AdvancedFilterFormData();

  get openFilter() {
    return (this.$refs as any)?.opAdvancedFilterBooking?.visible;
  }
  onOpenFilter(event: any) {
    const ref: any = this.$refs?.opAdvancedFilterBooking;
    ref?.toggle(event);
  }

  get accountIsForeign(): boolean {
    return AccountController.accountData.accountIsForeign;
  }

  expandedStatus: Record<number, boolean> = {};
  // nested status filted options
  get nestedStatusOptions() {
    return [
      {
        name: this.$t("bookingShipment.filterLabels.ongoingStatus"),
        isExpand: false,
        children: [
          {
            name: "BKD",
            value: "BKD"
          },
          {
            name: "PUP",
            value: "PUP"
          },
          {
            name: "STI-SC",
            value: "STI-SC"
          },
          {
            name: "STI",
            value: "STI"
          },
          {
            name: "BAGGING",
            value: "BAGGING"
          },
          {
            name: "CARGO PLANE",
            value: "CARGO PLANE"
          },
          {
            name: "CARGO TRUCK",
            value: "CARGO TRUCK"
          },
          {
            name: "CARGO TRAIN",
            value: "CARGO TRAIN"
          },
          {
            name: "CARGO SHIP",
            value: "CARGO SHIP"
          },
          {
            name: "PICKUP TRUCK",
            value: "PICKUP TRUCK"
          },
          {
            name: "DROPOFF TRUCK",
            value: "DROPOFF TRUCK"
          },
          {
            name: "TRANSIT",
            value: "TRANSIT"
          },
          {
            name: "STI-DEST",
            value: "STI-DEST"
          },
          {
            name: "HND",
            value: "HND"
          },
          {
            name: "DEL",
            value: "DEL"
          },
          {
            name: "STT REMOVE",
            value: "STT REMOVE"
          },
          {
            name: "STT ADJUSTED",
            value: "STT ADJUSTED"
          },
          {
            name: "HAL",
            value: "HAL"
          },
          {
            name: "ODA",
            value: "ODA"
          },
          {
            name: "OCC",
            value: "OCC"
          },
          {
            name: "STO-SC",
            value: "STO-SC"
          },
          {
            name: "OCC-HAL",
            value: "OCC-HAL"
          },
          {
            name: "OCC-EXP",
            value: "OCC-EXP"
          },
          {
            name: "OCC-IMP",
            value: "OCC-IMP"
          },
          {
            name: "INTHND",
            value: "INTHND"
          },
          {
            name: "INT-STI",
            value: "INT-STI"
          },
          {
            name: "IN-HUB",
            value: "IN-HUB"
          },
          {
            name: "OUT-HUB",
            value: "OUT-HUB"
          },
          {
            name: "KONDISPATCH",
            value: "KONDISPATCH"
          },
          {
            name: "STLDISPATCH",
            value: "STLDISPATCH"
          },
          ...(this.isAccountCountryMY || this.isInternalAccount
            ? [
                {
                  name: "RCC-IMP",
                  value: "RCC-IMP"
                }
              ]
            : [])
        ]
      },
      {
        name: this.$t("bookingShipment.filterLabels.troubledStatus"),
        isExpand: false,
        children: [
          {
            name: "DEX",
            value: "DEX"
          },
          {
            name: "SCRAP",
            value: "SCRAP"
          },
          {
            name: "SHORTLAND",
            value: "SHORTLAND"
          },
          {
            name: "MIS-ROUTE",
            value: "MIS-ROUTE"
          },
          {
            name: "CODREJ",
            value: "CODREJ"
          },
          {
            name: "MISSING",
            value: "MISSING"
          },
          {
            name: "DAMAGE",
            value: "DAMAGE"
          },
          {
            name: "NOT RECEIVED",
            value: "NOT RECEIVED"
          },
          {
            name: "MISBOOKING",
            value: "MISBOOKING"
          },
          {
            name: "REJECTED",
            value: "REJECTED"
          }
        ]
      },
      {
        name: this.$t("bookingShipment.filterLabels.finalStatus"),
        isExpand: false,
        children: [
          {
            name: "POD",
            value: "POD"
          },
          {
            name: "CNX",
            value: "CNX"
          },
          {
            name: "RTS",
            value: "RTS"
          },
          {
            name: "CLAIM",
            value: "CLAIM"
          },
          {
            name: "CI",
            value: "CI"
          },
          {
            name: "RTSHQ",
            value: "RTSHQ"
          },
          {
            name: "STT ADJUSTED POD",
            value: "STT ADJUSTED POD"
          },
          {
            name: "REROUTE",
            value: "REROUTE"
          },
          {
            name: "CNXCD",
            value: "CNXCD"
          },
          {
            name: "HALCD",
            value: "HALCD"
          },
          {
            name: "SCRAPCD",
            value: "SCRAPCD"
          }
        ]
      }
    ];
  }

  // Origin destination
  fetchOriginDestination = (search: string, type: string) => {
    search = search.split("-")[0];
    const countryCode = type === "origin" ? getCountryScopeParam() : "";
    if (search.length === 0) {
      if (type === "origin") {
        this.filterData.originCode = "";
        this.form.origin = "";
      } else if (type === "destination") {
        this.filterData.destinationCode = "";
        this.form.destination = "";
      }
      RouteController.getLocationSearchList({
        type: type,
        page: 1,
        limit: 10,
        search: countryCode === "MY" ? "kual" : "jaka",
        countryCode
      });
    } else if (search.length > 2) {
      RouteController.getLocationSearchList({
        type: type,
        page: 1,
        limit: 10,
        search: search,
        countryCode
      });
    }
  };
  get loadingOriginDestination() {
    return RouteController.isLoadingLocation;
  }

  get originList() {
    return RouteController.locationSearchOriginList.locationSearchData;
  }

  get destinationList() {
    return RouteController.locationSearchDestinationList.locationSearchData;
  }

  onChangeOrigin() {
    this.filterData.originCode = this.form.origin.code || "";
    this.filterData.districtId = this.form.origin.id || "";
    this.$emit("change", this.filterData);
    this.$emit("update:modelValue", this.filterData);
  }

  applyFilter(flag?: { isFromLisPickup?: boolean }) {
    this.$emit("changeFilter", this.filterData, flag);
  }

  resetToDefaultFilter(flag?: { isViewStt?: boolean }) {
    this.resetfilter();
    ShipmentBookingController.setAdvanceFilterData({
      periodeStart: "",
      periodeEnd: "",
      originCode: "",
      destinationCode: "",
      clientPartnerId: "",
      status: "",
      product: [],
      COD: false,
      PAD: false,
      DFOD: false,
      asuransi: [],
      nestedStatus: []
    });
    this.$emit("resetFilter", flag);
  }

  //date range picker
  setPeriode(value: Array<any>) {
    this.filterData.periodeStart = value[0];
    this.filterData.periodeEnd = value[1];
    this.onChange();
  }

  // client
  fetchClientPartner(search: string) {
    const countryCode = getCountryScopeParam();
    if (search.length === 0) {
      this.filterData.clientPartner = "";
      this.form.client = "";
      ClientController._onGetListPartner({
        page: 1,
        limit: 50,
        search: search,
        partnerType: "",
        countryCode
      });
    } else if (search.length > 2) {
      ClientController._onGetListPartner({
        page: 1,
        limit: 50,
        search: search,
        partnerType: "",
        countryCode
      });
    }
  }

  get loadingClientPartner() {
    return ClientController.isLoading;
  }

  get clientPartnerData() {
    return ClientController.clientPartnerData;
  }

  onChangeClient() {
    this.filterData.clientPartner = this.form.client.code;
    this.filterData.clientPartnerId = this.form.client.id;
    this.filterData.clientPartnerName = this.form.client.name;
    this.$emit("change", this.filterData);
    this.$emit("update:modelValue", this.filterData);
  }

  //status
  statusOpened = false;
  selectedStatus = "";
  get statusOptions() {
    const statusFilter = [
      { name: "BKD", value: "bkd" },
      { name: "PUP", value: "pup" },
      { name: "STI-SC", value: "sti-sc" },
      { name: "STO-SC", value: "sto-sc" },
      { name: "STI", value: "sti" },
      { name: "BAGGING", value: "bagging" },
      { name: "ECARGO", value: "ecargo" },
      { name: "TRUCK", value: "truck" },
      { name: "TRANSIT", value: "transit" },
      { name: "STI-DEST", value: "sti-dest" },
      { name: "STO-DEST", value: "sto-dest" },
      { name: "STI DEST-SC", value: "sti dest-sc" },
      { name: "STO DEST-SC", value: "sto dest-sc" },
      { name: "DEL", value: "del" },
      { name: "POD", value: "pod" },
      { name: "STT ADJUSTED POD", value: "STT ADJUSTED POD" },
      { name: "DEX", value: "dex" },
      { name: "CNX", value: "cnx" },
      { name: "STT REMOVE", value: "stt remove" },
      { name: "SCRAP", value: "scrap" },
      { name: "SHORTLAND", value: "shortland" },
      { name: "MIS-ROUTE", value: "mis-route" },
      { name: "STT ADJUSTED", value: "stt adjusted" },
      { name: "HAL", value: "hal" },
      { name: "ODA", value: "oda" },
      { name: "CODREJ", value: "codrej" },
      { name: "SDEX", value: "sdex" },
      { name: "SPOD", value: "spod" },
      { name: "REJECTED", value: "rejected" },
      { name: "REROUTE", value: "reroute" },
      { name: "MISBOOKING", value: "misbooking" },
      { name: "RTS", value: "rts" },
      { name: "RTSHQ", value: "rtshq" },
      { name: "TFDREQ", value: "tfdreq" },
      { name: "DELTRF", value: "deltrf" },
      { name: "TFDCNC", value: "tfdcnc" },
      { name: "CNXCD", value: "cnxcd" },
      { name: "OCC-HAL", value: "occ-hal" },
      { name: "OCC-EXP", value: "occ-exp" },
      { name: "OCC-IMP", value: "occ-imp" },
      { name: "INTHND", value: "inthnd" },
      { name: "INT-STI", value: "int-sti" }
    ];

    if (this.isAddedStatus) {
      statusFilter.splice(1, 0, { name: "PUP-C", value: "pup-c" });
    }
    return statusFilter;
  }
  get isAddedStatus() {
    return (
      AccountController.accountData.isPosChildAccount ||
      AccountController.accountData.isInternalAccount
    );
  }
  onSelectStatus(status: any) {
    if (this.filterData.status === status.value) {
      this.filterData.status = "";
    } else {
      this.filterData.status = status.value;
    }
    this.selectedStatus = status.name;
    this.statusOpened = false;
    this.onChange();
  }
  //product
  filterProductsDelivery = debounce((search: string) => {
    BookingController.getProductsDelivery({
      search: search,
      page: 1,
      limit: 99,
      status: "active"
    });
  }, 250);

  get productOptions() {
    const listData = BookingController.productsDelivery.data.map((e: any) => ({
      id: e.id,
      name: mapProductTypeName(e.name),
      code: e.name,
      status: e.status
    }));

    const filteredData = this.accountIsForeign
      ? listData.filter(
          (item) => item.code === "INTERPACKMAXI" || item.code === "INTERPACK" || item.code === "REGPACK"
        )
      : listData;

    return filteredData;
  }

  //cod
  COD = false;

  //asuransi
  getInsurancesTypeDelivery = debounce(() => {
    BookingController.getInsuranceTypesDelivery({
      insuranceConfig: 2
    });
  }, 250);
  get asuransiOptions() {
    const insurance: { [x: string]: string } = {
      basic: this.$t("bookingShipment.filterLabels.yes"),
      free: this.$t("bookingShipment.filterLabels.no")
    };
    return BookingController.allInsuranceTypeDelivery.data
      .filter((e) => e.value !== "premium")
      .map((e: any) => ({
        name: insurance[e.value?.toLowerCase()],
        code: e.name.replace("Asuransi", "Insurance")
      }))
      .reverse();
  }

  get sumFilterCity() {
    return (
      (this.filterData.originCode ? 1 : 0) +
      (this.filterData.destinationCode ? 1 : 0)
    );
  }
  get sumFilterDateAndCreatedBy() {
    return this.filterData.periodeStart && this.filterData.periodeEnd ? 1 : 0; // periode seharusnya dihitung satu filter
    // return (
    //   (this.filterData.periodeStart ? 1 : 0) +
    //   (this.filterData.periodeEnd ? 1 : 0)
    // );
  }
  get sumFilterBookingRelated() {
    return (
      this.filterData.nestedStatus.length +
      this.filterData.product.length +
      (this.filterData.COD.toString() == "true" ? 1 : 0) +
      (this.filterData.PAD ? 1 : 0) +
      (this.filterData.DFOD ? 1 : 0) +
      this.filterData.asuransi.length +
      (this.filterData.status ? 1 : 0)
    );
  }
  get totalFilter() {
    return (
      this.sumFilterCity +
      this.sumFilterBookingRelated +
      this.sumFilterDateAndCreatedBy +
      (this.filterData.clientPartner ? 1 : 0) +
      (this.filterData.phoneReceiver ? 1 : 0) +
      (this.filterData.phoneSender ? 1 : 0)
    );
  }

  onChange() {
    this.$emit("change", this.filterData);
    this.$emit("update:modelValue", this.filterData);
  }

  get formOrigin() {
    let origin = "";
    if (this.form.origin?.name) {
      origin = this.form.origin?.name;
    } else {
      origin = this.form.origin;
    }
    return origin;
  }

  get formDestination() {
    let destination = "";
    if (this.form.destination?.name) {
      destination = this.form.destination?.name;
    } else {
      destination = this.form.destination;
    }
    return destination;
  }

  get formClient() {
    let client = "";
    if (this.form.client?.name) {
      client = this.form.client?.name;
    } else {
      client = this.form.client;
    }
    return client;
  }

  onChangeDestination() {
    this.filterData.destinationCode = this.form.destination.code || "";
    this.$emit("change", this.filterData);
    this.$emit("update:modelValue", this.filterData);
  }

  // partner name
  partnerNameOpened = false;
  selectedPartnerName = "";
  get partnerNameOptions() {
    return ClientController.clientPartnerData.map((e) => ({
      name: e.name,
      value: e.code
    }));
  }

  // product
  fetchProduct(search: string) {
    BookingController.getProductsDelivery({
      search: search,
      page: 1,
      limit: 99,
      status: "active"
    });
  }

  filterProduct = debounce((search: string) => {
    this.fetchProduct(search);
  }, 250);

  get shipmentProductOptions() {
    return [
      {
        id: 0,
        name: "All",
        value: ""
      },
      ...BookingController.productsDelivery.data.map((e: any) => ({
        id: e.id,
        name: e.name,
        value: e.name
      }))
    ];
  }
  get isLoadingProduct() {
    return BookingController.loadingProductsDelivery;
  }

  // phone receiver
  phoneReceiver = "";
  phoneCodeReceiver = getPhoneDisplayCode(
    AccountController.accountData?.countryCode
  );
  phoneFlagReceiver = !this.accountIsForeign ? "indonesia" : "malaysia";
  setPhoneReceiver(val: string) {
    this.phoneReceiver = val;
    if (!val && this.filterData.phoneReceiver) {
      this.filterData.phoneReceiver = val;
      this.$emit("change", this.filterData);
    }
  }

  setPhoneCodeReceiver(val: string) {
    this.phoneCodeReceiver = val;
  }

  setPhoneFlagReceiver(val: string) {
    this.phoneFlagReceiver = val;
  }

  onSearchPhoneReceiver() {
    this.filterData.phoneReceiver = `${this.phoneCodeReceiver.substring(1)}${
      this.phoneReceiver
    }`;
    this.$emit("change", this.filterData);
  }

  // phone sender
  get isAccountOriginMY(): boolean {
    const account = AccountController.accountData;
    if (account.isInternalAccount) {
      return (account.hqCountry || "").toUpperCase() === "MY";
    }
    return (
      (account.account_type_detail?.countryCode || "").toUpperCase() === "MY"
    );
  }

  get defaultPhoneCodeSender(): string {
    return this.isAccountOriginMY ? "+60" : "+62";
  }

  get defaultPhoneFlagSender(): string {
    return this.isAccountOriginMY ? "malaysia" : "indonesia";
  }

  phoneSender = "";
  phoneCodeSender = this.defaultPhoneCodeSender;
  phoneFlagSender = this.defaultPhoneFlagSender;
  setPhoneSender(val: string) {
    this.phoneSender = val;
    if (!val && this.filterData.phoneSender) {
      this.filterData.phoneSender = val;
      this.$emit("change", this.filterData);
    }
  }

  setPhoneCodeSender(val: string) {
    this.phoneCodeSender = val;
  }

  setPhoneFlagSender(val: string) {
    this.phoneFlagSender = val;
  }

  onSearchPhoneSender() {
    this.filterData.phoneSender = `${this.phoneCodeSender.substring(1)}${
      this.phoneSender
    }`;
    this.$emit("change", this.filterData);
  }

  isParentSelected(index: number) {
    const statuses = this.nestedStatusOptions[index].children.map((status) =>
      status.value.toUpperCase()
    );

    return !statuses
      .map((status) => this.filterData.nestedStatus.includes(status))
      .includes(false);
  }

  selectParentStatus(index: number) {
    const statuses = this.nestedStatusOptions[index].children.map((status) =>
      status.value.toUpperCase()
    );

    if (this.isParentSelected(index)) {
      statuses.forEach((status) => {
        this.filterData.nestedStatus = this.filterData.nestedStatus.filter(
          (stat: string) => stat.toUpperCase() !== status
        );
      });
    } else {
      this.filterData.nestedStatus = [
        ...this.filterData.nestedStatus,
        ...statuses
      ];
    }

    this.$emit("change", this.filterData);
  }

  selectChildNestedStatus(status: string): void {
    if (this.filterData.nestedStatus.includes(status)) {
      this.filterData.nestedStatus = this.filterData.nestedStatus.filter(
        (stat: string) => stat.toUpperCase() !== status.toUpperCase()
      );
    } else {
      this.filterData.nestedStatus = [...this.filterData.nestedStatus, status];
    }

    this.$emit("change", this.filterData);
  }

  onSetNestedStatus(statuses: string[]) {
    this.filterData.nestedStatus = statuses;
    this.$emit("change", this.filterData);
  }

  get isAccountCountryMY() {
    return (
      AccountController.accountData.account_type_detail.countryCode?.toLowerCase() ===
      "my"
    );
  }

  get isInternalAccount() {
    return AccountController.accountData.isInternalAccount;
  }

  get isEnableCodBooking() {
    return FlagsMedusa.config_new_cod_booking_enable.isEnabled();
  }
}
